import React from "react";

import clsx from "clsx";

import { Heading } from "@busbud/horizon";

interface Props {
  title: string;
  xsOnly?: boolean;
  children: React.ReactNode;
}

export const WithTitle: React.FC<Props> = ({
  children,
  title,
  xsOnly = false
}) => {
  return (
    <>
      <Heading
        as="p"
        className={clsx("mb-200 font-weight-bold text-color-tertiary", {
          ["sm:hidden"]: xsOnly
        })}
        size="xxs"
      >
        {title}
      </Heading>
      {children}
    </>
  );
};
